import ApiService from './api.service'
import { TokenService } from './storage.service'

const MfaService = {
    verify: async function(mfaToken, code, method) {
        const response = await ApiService.customRequest({
            method: 'post',
            url: '/api/auth/verify-mfa',
            data: { MfaToken: mfaToken, Code: code, Method: method || 'email' }
        })

        const userData = {
            id: parseInt(response.data.id),
            userName: response.data.userName,
            fullName: response.data.fullName,
            roles: response.data.roles,
        }
        TokenService.saveUserData(userData)
        TokenService.saveToken(response.data.access_token)
        ApiService.setHeader()
        ApiService.mount401Interceptor()

        if (response.data.mfa_device_token) {
            TokenService.saveMfaDeviceToken(response.data.mfa_device_token)
        }

        return response.data.access_token
    },

    resend: async function(mfaToken) {
        return ApiService.customRequest({
            method: 'post',
            url: '/api/auth/resend-mfa',
            data: { MfaToken: mfaToken }
        })
    },

    fallbackToEmail: async function(mfaToken) {
        const response = await ApiService.customRequest({
            method: 'post',
            url: '/api/auth/mfa-fallback-to-email',
            data: { MfaToken: mfaToken }
        })
        return response.data
    }
}

export default MfaService
export { MfaService }
